import { render, staticRenderFns } from "./TripItems.vue?vue&type=template&id=53075cf2&scoped=true&"
import script from "./TripItems.vue?vue&type=script&lang=js&"
export * from "./TripItems.vue?vue&type=script&lang=js&"
import style0 from "./TripItems.vue?vue&type=style&index=0&id=53075cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53075cf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53075cf2')) {
      api.createRecord('53075cf2', component.options)
    } else {
      api.reload('53075cf2', component.options)
    }
    module.hot.accept("./TripItems.vue?vue&type=template&id=53075cf2&scoped=true&", function () {
      api.rerender('53075cf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Trips/Components/TripItems.vue"
export default component.exports